import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as faqChatSlice from "../../../../redux/slices/faqChatSlice";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { Trash } from "feather-icons-react/build/IconComponents";
import { NotePencil } from "@phosphor-icons/react";

const FaqSubTopics = () => {
  const [showEditSubTopicModal, setShowEditSubTopicModal] = useState(false);
  const [form, setForm] = useState({});
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [subTopicId, setSubTopicId] = useState();
  const { allTopics, allSubTopics, loading } = useSelector(
    (state) => state.faqChatSlice
  );

  // Modal state for adding subTopic
  const [showAddSubTopicModal, setShowAddSubTopicModal] = useState(false);

  useEffect(() => {
    if (!showEditSubTopicModal) {
      setForm({});
    }
    dispatch(faqChatSlice.getSubTopics());
    dispatch(faqChatSlice.getTopics());
  }, [dispatch]);

  // Handle delete
  const handleDelete = async (subTopicId) => {
    await dispatch(faqChatSlice.destroySubTopic(subTopicId));
    dispatch(faqChatSlice.getSubTopics());
    setDeleteModal(false);
  };

  // DataTable columns definition
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Main Topic",
      selector: (row) => row?.main_topic?.topic || "-",
      sortable: true,
    },
    {
      name: "Sub-Topic",
      selector: (row) => row?.sub_topic || "-",
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <div className="delete">
            <Trash onClick={() => handleDelete(row.id)} size={19} />
          </div>
          <div
            className="edit ml-1"
            onClick={() => {
              handleOnEditClick(row.id);
              setShowAddSubTopicModal(true);
              setIsEdit(true);
            }}
          >
            <NotePencil size={18} />
          </div>
        </div>
      ),
    },
  ];

  const handleOnEditClick = (id) => {
    const data = allSubTopics?.find((h) => h?.id === id);
    setSubTopicId(data?.id);
    setForm({
      ...form,
      topic_id: data?.topic_id,
      sub_topic: data?.sub_topic,
    });
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (!form?.sub_topic) {
      toast("Enter subTopic name, please");
      return;
    }
    await dispatch(faqChatSlice.updateSubTopic(subTopicId, form, setForm));
    setShowAddSubTopicModal(false);
    dispatch(faqChatSlice.getSubTopics());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form?.sub_topic) {
      toast("Enter subTopic name, please");
      return;
    }
    await dispatch(faqChatSlice.storeSubTopic(form, setForm));
    setShowAddSubTopicModal(false);
    dispatch(faqChatSlice.getSubTopics());
  };

  return (
    <>
      <h5 className="mb-4">FAQ Sub-Topic</h5>

      <Row className="mt-4">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <Button
            style={{
              backgroundColor: "#e8783d",
              border: "none",
              marginBottom: "1vh",
            }}
            onClick={() => {
              setIsEdit(false);
              setForm({});
              setShowAddSubTopicModal(true);
            }}
          >
            Add
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={(allSubTopics?.length && allSubTopics) || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      {/* Add SubTopic Modal */}
      <Modal
        show={showAddSubTopicModal}
        // onHide={() => setShowAddSubTopicModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w"
      >
        <Modal.Header >
          <Modal.Title>{isEdit ? "Update" : "Add"} Sub-Topic</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formTopic" className="mb-3">
              <Form.Label>Select Topic</Form.Label>
              <Form.Control
                as="select"
                value={form?.topic_id || ""}
                onChange={(e) => setForm({ ...form, topic_id: e.target.value })}
                required
              >
                <option value="" disabled>
                  Select a main topic
                </option>
              
                {allTopics.map((topic) => (
          <option key={topic.id} value={topic.id} title={topic.topic}>
            {topic.topic.length > 50 ? `${topic.topic.slice(0, 50)}...` : topic.topic}
          </option>
        ))}
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="formSubTopic" className="mb-3">
              <Form.Label>Enter Sub-Topic</Form.Label>
              <Form.Control
                type="text"
                value={form?.sub_topic || ""}
                onChange={(e) =>
                  setForm({ ...form, sub_topic: e.target.value })
                }
                placeholder="Enter Sub-Topic Here"
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAddSubTopicModal(false)}
          >
            Close
          </Button>
          {isEdit ? (
            <Button variant="primary" type="submit" onClick={handleUpdate}>
              Update
            </Button>
          ) : (
            <Button variant="primary" type="submit" onClick={handleSubmit}>
              Save
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FaqSubTopics;
